// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import { Paper, Tab, Tabs, Typography } from '@mui/material'
import cx from 'classnames'
import React from 'react'
import { Trans } from 'react-i18next'
import { getTotalWeight, getTotalWeightColor } from '../../../common/weight/weightHelpers'
import { i18n } from '../../index'
import type { BuffetWeight, BuffetWeightWeekday, Station } from '../../station/stationTypes'
import BuffetGeneralForm from './BuffetGeneralForm'
import BuffetWeightsForm from './BuffetWeightsForm'
import StationPage from './StationPage'
import css from './stationPage.css'

const buffetWeekdays = ['Weekday', 'Friday', 'Saturday', 'Sunday']

const getSubtitleOptions = (weights: Array<BuffetWeight>) => {
  const totalWeight = getTotalWeight(weights)
  return {
    color: getTotalWeightColor(totalWeight),
    totalWeight,
  }
}

type BuffetWeightsTabProps = {
  station: Station
  weekday: BuffetWeightWeekday
}

const BuffetWeightsTab = ({ station, weekday }: BuffetWeightsTabProps) => {
  const { color, totalWeight } = getSubtitleOptions(
    (station.buffetWeights && station.buffetWeights[weekday.toLowerCase()]) || [],
  )
  return (
    <div className={css.tab}>
      <Typography variant='subtitle2' className={cx(css.subtitle, css.tabSubtitle)}>
        <Trans
          i18nKey='admin.stations.title.buffetWeightsTab'
          values={{ totalWeight }}
          components={{ totalWeight: <span style={{ color }} /> }}
        />
      </Typography>
      <BuffetWeightsForm
        stationId={station.id}
        buffetBeginAt={station.buffetBeginAt}
        buffetEndAt={station.buffetEndAt}
        weekday={weekday}
        data={(station.buffetWeights && station.buffetWeights[weekday.toLowerCase()]) || []}
      />
    </div>
  )
}

type StationBuffetPageState = {
  activeTab: BuffetWeightWeekday
}

class StationBuffetPage extends React.Component<any, StationBuffetPageState> {
  state = {
    activeTab: 'Weekday',
  }
  onTabChange = (tabName: BuffetWeightWeekday) => {
    this.setState({
      activeTab: tabName,
    })
  }

  render() {
    const { activeTab } = this.state
    return (
      <StationPage title={i18n.t('admin.stations.title.buffetPage')}>
        {({ station }) => (
          <div className={css.content}>
            <div className={css.section}>
              <Typography variant='subtitle1' className={css.subtitle}>
                {i18n.t('admin.stations.title.buffetGeneralInfo')}
              </Typography>
              <Paper>
                <div className={css.inner}>
                  <BuffetGeneralForm data={station} />
                </div>
              </Paper>
            </div>
            <div className={css.section}>
              <Typography variant='subtitle1' className={css.subtitle}>
                {i18n.t('admin.stations.title.buffetWeights')}
              </Typography>
              <Paper>
                <Tabs
                  className={css.tabs}
                  indicatorColor='primary'
                  textColor='primary'
                  value={activeTab}
                  onChange={(e, value) => this.onTabChange(value)}
                >
                  {buffetWeekdays.map((weekday) => (
                    <Tab
                      value={weekday}
                      label={i18n.t(`admin.stations.tab.buffetWeekday${weekday}`)}
                      key={weekday}
                      disableRipple
                    />
                  ))}
                </Tabs>
                <BuffetWeightsTab station={station} weekday={activeTab} />
              </Paper>
            </div>
          </div>
        )}
      </StationPage>
    )
  }
}

export default StationBuffetPage
